import {
  setMenuLoading,
  setMenuFailed,
  setMenuData,
  setRolesLoading,
  setRolesFailed,
  setRolesData,
} from './actions'
import fetchAPI, { IHttpError } from '../../../lib/utils/fetch-api'
import { ResultStatusType } from 'antd/lib/result'

export function getMenuData() {
  return async dispatch => {
    dispatch(setMenuLoading())
    try {
      const response = await fetchAPI('/api/admin/menu')
      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setMenuFailed({ statusCode: 'error', message: error }))
      }
      return dispatch(setMenuData(response || []))
    } catch (err) {
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = ((err as IHttpError)?.statusCode || 'error') as ResultStatusType
      return dispatch(setMenuFailed({ statusCode, message }))
    }
  }
}

export function saveMenuData(menuData: any) {
  return async dispatch => {
    dispatch(setMenuLoading())
    try {
      const response = await fetchAPI('/api/admin/menu', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(menuData),
      })

      if (response['errors']) {
        let error = response['errors']
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setMenuFailed({ statusCode: 'error', message: error }))
      }

      return dispatch(setMenuData(response.data))
    } catch (err) {
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = ((err as IHttpError)?.statusCode || 'error') as ResultStatusType
      return dispatch(setMenuFailed({ statusCode, message }))
    }
  }
}

export function getRolesData() {
  return async dispatch => {
    dispatch(setRolesLoading())
    try {
      const response = await fetchAPI('/api/roles/list')
      if (response.errors) {
        let error = response.errors
        if (Array.isArray(error)) {
          error = error.join()
        }
        return dispatch(setRolesFailed({ statusCode: 'error', message: error }))
      }
      return dispatch(setRolesData(response || []))
    } catch (err) {
      const message = (err as IHttpError)?.message || 'При загрузки полей возникла ошибка'
      const statusCode = ((err as IHttpError)?.statusCode || 'error') as ResultStatusType
      return dispatch(setMenuFailed({ statusCode, message }))
    }
  }
}
